export default function DevicesSection() {
  const devices = [
    'Amazon Firestick/ Amazon Fire TV',
    'All Smart TVs',
    'All Mobile Phones/ Tablets',
    'All Apple Devices iPhone/iMac/Macbook',
    'All Android Box/ Android TVs',
    'Formuler Devices',
    'Magbox, Laptop, Windows'
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left - Image */}
          <div className="w-full h-96">
            <img 
              src="https://public.readdy.ai/ai/img_res/7ac43aca22338c27efc5303eda92a4ee.jpg"
              alt="Compatible Devices"
              className="w-full h-full object-cover object-top rounded-lg shadow-lg"
            />
          </div>

          {/* Right - Content */}
          <div>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
              All Devices Covered
            </h2>
            <p className="text-lg text-gray-600 mb-8">
              Seamless device configuration and optimization on any platform, anywhere. Expert setup assistance with a user-friendly approach for the ultimate entertainment experience.
            </p>
            
            <ul className="space-y-4">
              {devices.map((device, index) => (
                <li key={index} className="flex items-center">
                  <div className="w-6 h-6 bg-green-500 rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                    <i className="ri-check-line text-white text-sm"></i>
                  </div>
                  <span className="text-gray-700">{device}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
